var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "ul",
      { staticClass: "rc-info-tabs" },
      _vm._l(_vm.tabRefs, function (tab, key) {
        return _c(
          "li",
          {
            class: {
              active: tab.visible,
              "striped-link-on": tab.visible,
              "striped-link": !tab.visible,
            },
          },
          [
            _c(
              "a",
              {
                attrs: { role: "button", tabindex: "0" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.switchTab(key)
                  },
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(tab.tabName) +
                    "\n                "
                ),
              ]
            ),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "rc-info-content" },
      _vm._l(_vm.tabRefs, function (tab) {
        return _c(
          "div",
          { staticStyle: { position: "relative" } },
          [
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: tab.visible,
                  expression: "tab.visible",
                },
              ],
              attrs: { id: tab.external },
            }),
            _vm._v(" "),
            _vm.userAuthenticated
              ? _c("content-editor", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: tab.visible,
                      expression: "tab.visible",
                    },
                  ],
                  attrs: {
                    "start-height": "250",
                    "update-url": _vm.updateUrl,
                    "instance-id": tab.action,
                    action: tab.action,
                    "display-id": tab.external,
                    "allow-embeds": true,
                  },
                })
              : _vm._e(),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }